import { BristolCityLogo } from '@jouzen/ecom-components/icons/BristolCityLogo';
import { CignaLogo } from '@jouzen/ecom-components/icons/CignaLogo';
import { MlbLogo } from '@jouzen/ecom-components/icons/MlbLogo';
import { NascarLogo } from '@jouzen/ecom-components/icons/NascarLogo';
import { NewYorkKnicksLogo } from '@jouzen/ecom-components/icons/NewYorkKnicksLogo';
import { SeattleSoundersFcLogo } from '@jouzen/ecom-components/icons/SeattleSoundersFcLogo';
import { StravaLogo } from '@jouzen/ecom-components/icons/StravaLogo';
import { UnimedLogo } from '@jouzen/ecom-components/icons/UnimedLogo';
import { UniversityOfVirginiaLogo } from '@jouzen/ecom-components/icons/UniversityOfVirginiaLogo';
import { UnofficialPharmanutraLogo } from '@jouzen/ecom-components/icons/UnofficialPharmanutraLogo';
import { UsArmyLogo } from '@jouzen/ecom-components/icons/UsArmyLogo';
import { WashingtonSpiritSeekLogo } from '@jouzen/ecom-components/icons/WashingtonSpiritSeekLogo';
import { YextLogo } from '@jouzen/ecom-components/icons/YextLogo';
import { cx } from 'class-variance-authority';
import type { SVGIconComponent } from 'types/svgr';

import type { LandingPageIntegrationData } from '@/app/components/LandingPage/LandingPageIntegrations/types';

export const customers: LandingPageIntegrationData[] = [
  {
    name: 'Nascar',
    Logo: NascarLogo as SVGIconComponent,
  },
  {
    name: 'MLB',
    Logo: MlbLogo as SVGIconComponent,
  },
  {
    name: 'New York Knicks',
    Logo: NewYorkKnicksLogo as SVGIconComponent,
  },
  {
    name: 'Bristol City',
    Logo: BristolCityLogo as SVGIconComponent,
    logoClassName: 'md:w-24',
  },
  {
    name: 'Seattle Sounders FC',
    Logo: SeattleSoundersFcLogo as SVGIconComponent,
  },
  {
    name: 'Strava',
    Logo: StravaLogo as SVGIconComponent,
  },
  {
    name: 'Yext',
    Logo: YextLogo as SVGIconComponent,
  },
  {
    name: 'Washington Spirit',
    Logo: WashingtonSpiritSeekLogo as SVGIconComponent,
  },
  {
    name: 'US Army',
    Logo: UsArmyLogo as SVGIconComponent,
  },
  {
    name: 'Unimed',
    Logo: UnimedLogo as SVGIconComponent,
  },
  {
    name: 'Pharmanutra',
    Logo: UnofficialPharmanutraLogo as SVGIconComponent,
    logoClassName: 'md:w-64',
  },
  {
    name: 'Cigna',
    Logo: CignaLogo as SVGIconComponent,
  },
  {
    name: 'University of Virginia',
    Logo: UniversityOfVirginiaLogo as SVGIconComponent,
  },
].map((integration) => ({
  ...integration,
  logoClassName: cx('sm:h-16 md:h-auto', integration.logoClassName),
}));
